import { render, staticRenderFns } from "./TrustDocVerifyResendSMS.vue?vue&type=template&id=1502361a&scoped=true"
import script from "./TrustDocVerifyResendSMS.vue?vue&type=script&lang=js"
export * from "./TrustDocVerifyResendSMS.vue?vue&type=script&lang=js"
import style0 from "./TrustDocVerifyResendSMS.vue?vue&type=style&index=0&id=1502361a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1502361a",
  null
  
)

export default component.exports